import { render, staticRenderFns } from "./Producciones.vue?vue&type=template&id=df756bfa&scoped=true"
import script from "./Producciones.vue?vue&type=script&lang=js"
export * from "./Producciones.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Producciones.vue?vue&type=style&index=1&id=df756bfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df756bfa",
  null
  
)

export default component.exports